// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + {"218":"9c73bcce615b4c941cec","685":"d6802d59d2e6e2976a27","871":"6aa511774e4c4a3ee7e4"}[chunkId] + ".min.js";
};